<template>
  <div>
    <v-app-bar
      id="home-app-bar"
      app
      color="white"
      elevation="1"
      height="80"
    >
      <base-img
        :src="require('@/assets/4dlabs_logo_full_black.png')"
        class = "hidden-sm-and-up"
        contain
        max-width="100"
        width="100%"
      />
      <!-- <h2>4D Labs, Inc.</h2> -->

      <base-img

class="mr-3 hidden-xs-only"
        :src="require('@/assets/4dlabs_logo_full_black.png')"
        contain
        max-width="128"
        width="100%"
      />

      <v-spacer />

      <div>
        <v-tabs
          class="hidden-sm-and-down"
          optional
        >
          <!-- <v-tab

            :ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
          >
            Scroll to element
          </v-tab>
          <v-tab
            v-scroll-to="'#gallery'"
            href="#gallery"
            ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
          > -->
          <!-- <v-tab
            to="#gallery"
            exact="name === 'Home'"
            ripple="false"
            active-class="textprimary"
            class="font-weight-bold"
            min-width="96"
            text
          >
          Home
          </v-tab>
          <v-tab
            to="#gallery"
            exact="name === 'Artists'"
            ripple="false"
            active-class="textprimary"
            class="font-weight-bold"
            min-width="96"
            text
          >
          Artists
          </v-tab>
          <v-tab
            to="#news"
            exact="name === 'Home'"
            ripple="false"
            active-class="textprimary"
            class="font-weight-bold"
            min-width="96"
            text
          >
          Services
          </v-tab>
          <v-tab
            to="#news"
            exact="name === 'World'"
            ripple="false"
            active-class="textprimary"
            class="font-weight-bold"
            min-width="96"
            text
          >
          4th World
          </v-tab>
          <v-tab
            to="#news"
            exact="name === 'News'"
            ripple="false"
            active-class="textprimary"
            class="font-weight-bold"
            min-width="96"
            text
          >
          News
          </v-tab> -->
          <v-tab
            v-for="(item, i) in items2"
            :key="i"
            :to="item.link"
            :exact="item.name === 'Home'"
            :ripple="false"
            active-class="textprimary"
            class="font-weight-bold"
            min-width="96"
            text
          >
            {{item.name}}
          </v-tab>
        </v-tabs>
      </div>

      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click="drawer = !drawer"
      />
    </v-app-bar>

    <home-drawer
      v-model="drawer"
      :items="items2"
    />
  </div>
</template>

<script>
  export default {
    name: 'HomeAppBar',

    components: {
      HomeDrawer: () => import('./Drawer'),
    },

    data: () => ({
      drawer: null,
      items: [
        'Home',
        'About',
        'Marketing',
        'Gallery',
        'Pricing',
        'News',
        'Contact',
      ],
      items2: [
        {
          name: 'Home',
          link: '#hero',
        },
        {
          name: 'Digital Agency',
          link: '#social',
        },
        {
          name: 'Products',
          link: '#mobile',
        },
        {
          name: 'FAQ',
          link: '#theme-features',
        },
        {
          name: 'News',
          link: '#news',
        },
        {
          name: 'Contact',
          link: '#info-alt',
        },
      ],
    }),
  }
</script>

<style lang="sass">
  #home-app-bar
    .v-tabs-slider
      max-width: 24px
      margin: 0 auto

    .v-tab
      &::before
        display: none
</style>
